import { type TFunction } from 'i18next';

/**
 * Gets the subject for an inbox notification banner.
 * Checks if a translation exists for `{messageKey}:subject`.
 * If it exists, uses that. Otherwise returns the provided default.
 */
export const getInboxNotificationSubject = (
	messageKey: string,
	tI: TFunction,
	defaultSubject: string,
	data?: { [key: string]: any },
): string => {
	const subjectKey = `${messageKey}:subject`;
	const translated = tI(subjectKey, data as any) as string;

	// If translation exists (doesn't return the key itself), use it
	if (translated !== subjectKey) {
		return translated;
	}

	return defaultSubject;
};

/**
 * Gets the message for an inbox notification banner or dialog.
 * Checks if a translation exists for `{messageKey}:message`.
 * If it exists, uses that. Otherwise falls back to translating the messageKey with info.
 */
export const getInboxNotificationMessage = (
	messageKey: string,
	tI: TFunction,
	info?: { [key: string]: string | undefined },
	data?: { [key: string]: any },
): string => {
	const messageVariantKey = `${messageKey}:message`;
	const translated = tI(messageVariantKey, data as any) as string;

	// If translation exists (doesn't return the key itself), use it
	if (translated !== messageVariantKey) {
		return translated;
	}

	// Fall back to default translation with info
	return tI(messageKey, info);
};
